<template>
  <div id="printBodyPayslip">
    <h4 class="text-center">Расчётный листок за
      {{ getMonthName(params.period.month) + ' ' + params.period.year + ' г.' }}</h4>

    <table class="table table-sm table-bordered">
      <tr>
        <td>Организация: <strong>{{ org.name }}</strong></td>
        <td>Подразделение: <strong></strong></td>
      </tr>
      <tr>
        <td>Работник: <strong>{{ worker.last_name + ' ' + worker.first_name + ' ' + worker.middle_name }}</strong></td>
        <td>Должность: <strong>{{ worker.workerfunction }}</strong></td>
      </tr>
    </table>

    <table class="table table-sm table-bordered table-striped table-12" style="">
      <tbody>
      <tr>
        <th>Вид</th>
        <th>Период</th>
        <th>Дни</th>
        <th>Часы</th>
        <th>Сумма</th>
        <th>Вид</th>
        <th>Период</th>
        <th>Сумма</th>
      </tr>
      <tr>
        <th colspan="5">Начислено</th>
        <th colspan="3">Удержано</th>
      </tr>

      <tr v-for="(item, index) in result.list" :key="index">
        <td>{{ item.sum_name }}</td>
        <td>{{ item.sum_period }}</td>
        <td>{{ item.sum_days }}</td>
        <td>{{ item.sum_hours }}</td>
        <td class="text-right">{{ formatMoney(item.sum_value, 2) }}</td>
        <td>{{ item.deduction_name }}</td>
        <td>{{ item.deduction_period }}</td>
        <td class="text-right">{{ formatMoney(item.deduction_value, 2) }}</td>
      </tr>
      <tr>
        <td colspan="4">Итого начислено</td>
        <td class="text-right">{{ formatMoney(result.amount.sum, 2) }}</td>
        <td colspan="2">Итого удержано</td>
        <td class="text-right">{{ formatMoney(result.amount.deduction, 2) }}</td>
      </tr>
      <tr>
        <td colspan="4"><strong v-if="result.paid != 0">Уже выплачено за период</strong></td>
        <td class="text-right"><strong v-if="result.paid != 0">{{ formatMoney(result.amount.paid, 2) }}</strong></td>
        <td><strong>Итого к выплате</strong></td>
        <td colspan="2" class="text-right"><strong>{{ formatMoney(result.amount.pay, 2) }}</strong></td>
      </tr>
      </tbody>
    </table>

    <template v-if="params.description == 1">
      <template v-for="(item, index) in result.description">
        <CalcDescription :title="item.title" :key="index" :data="item.list" :laws="false" :expand="true" :show_result="true"></CalcDescription>
      </template>
    </template>


  </div>
</template>


<script>
import CalcDescription from "@/components/base/Description"
export default {
  components: {
    CalcDescription
  },
  props: ['result', 'org', 'worker', 'params']
}
</script>


<style>

</style>
